export default {
    'locale.de': 'Deutsch',
    'locale.en': 'Englisch',
    'login.title': 'Login',
    'login.label.email': 'E-Mail-Adresse',
    'login.label.password': 'Passwort',
    'login.btn.submit': 'Jetzt einloggen',
    'navigation.home': 'Start',
    'navigation.videos': 'Meine Videos',
    'navigation.projects': 'Meine Projekte',
    'navigation.faq': 'FAQ',
    'navigation.imprint': 'Impressum',
    'navigation.legal': 'AGBs',
    'navigation.privacy': 'Datenschutz',
    'navigation.logout': 'Logout',
    'imprint.text': require('./texts/de/imprint').default,
    'imprint.title': 'Impressum',
    'legal.text': require('./texts/de/legal').default,
    'legal.title': 'AGBs',
    'privacy.text': require('./texts/de/privacy').default,
    'privacy.title': 'Datenschutz',
    'faq.title': 'FAQ',
    'page404.text': require('./texts/de/page404').default,
    'page404.title': 'Seite nicht gefunden',
    'code.text': require('./texts/de/code').default,
    'project.instruction.buttons.redo': 'Aufnahme wiederholen',
    'project.instruction.buttons.repeat': 'Weitere Aufnahme',
    'project.instruction.buttons.skip': 'Überspringen',
};
